import { Component } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { NoticeComponent } from './shared/notice/notice.component';

@Component({
    selector: 'app-root',
    standalone: true,
    imports: [RouterOutlet, NoticeComponent],
    templateUrl: './app.component.html',
})
export class AppComponent {}
